import {Route, RouteComponentProps, Switch} from "react-router";
import {Link} from "react-router-dom";
import * as React from "react";
import {
    CardObject,
    CourseObject, useAllCoursesQuery,
    useReleaseMnemoCardsQuery, useReleaseMnemosMutation
} from "../../../../types.d";
import {CourseSidebar} from "../../../partials/CourseSidebar";
import {VocabularyModal} from "../../../partials/modals/VocabularyModal";
import {useState} from "react";

export const ReleaseMnemoPage = (props: RouteComponentProps) => {
    const { match } = props;

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Release mnemo cards
                    </li>
                </ol>
            </nav>

            <div className={'row pt-3'}>
                <CoursesList match={match} />

                <div className={'col col-9'}>
                    <Switch>
                        <Route path={`${match.path}/:course`} component={ReleaseMnemoTable} />
                    </Switch>
                </div>
            </div>
        </div>
    </div>
};

const CoursesList = props => {
    const courses = useAllCoursesQuery({
        fetchPolicy: 'no-cache'
    });

    if (!courses.data) {
        return null;
    }

    return <CourseSidebar
        basePath={props.match.path}
        courses={courses.data.courses as CourseObject[]} />
};

export const ReleaseMnemoTable = (props: RouteComponentProps<{ course: string }>) => {
    const courseId = Number(props.match.params.course);

    const [items, setItems] = useState([]);
    const [finished, setFinished] = useState(false);
    const cards = useReleaseMnemoCardsQuery({
        fetchPolicy: 'no-cache',
        variables: { courseId }
    });

    const [ releaseMnemos, { data: releasedResult } ] = useReleaseMnemosMutation();

    const updateItem = (id, value) => {
        if (!value) {
            setItems(items.filter(item => item !== id));
        } else {
            setItems([
                ...items,
                id
            ]);
        }
    };

    if (finished) {
        return <div className={'alert alert-success'}>Cards released</div>
    }

    return <>
        <table className="table table-bordered">
            <thead>
            <tr>
                <th scope="col" style={{ width: 120 }}>Exclude from MC</th>
                <th scope="col">Vocabulary</th>
                <th scope="col">Editor</th>
                <th scope="col">Reviewer</th>
                <th scope="col">Finisher</th>
            </tr>
            </thead>
            <tbody className="release-list">
                { cards.data && cards.data.unreleasedMnemos.map(item => (
                    <ReleaseMnemoRow
                        key={item.id}
                        onChanged={value => updateItem(item.id, value)}
                        card={item as CardObject} />
                )) }
            </tbody>
        </table>

        <button
           onClick={async e => {
               setFinished(true);

               await releaseMnemos({
                   variables: {
                       data: cards.data.unreleasedMnemos.map(item => ({
                           id: item.id,
                           excluded: items.includes(item.id)
                       }))
                   }
               });
           }}
           className={'btn btn-lg btn-primary'}>Release</button>
    </>
};

export const ReleaseMnemoRow = (props: { card: CardObject, onChanged: (value: boolean) => any }) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { card, onChanged } = props;

    return <tr>
        <td align="center">
            <input type="checkbox"
                   onChange={e => onChanged(e.target.checked)}
                   className="release-cards-checkbox"/>
        </td>
        <td>
            <a href="" onClick={e => {
                e.preventDefault();
                setModalVisible(true);
            }}>{ card.wordTranslation.sourceWord.lemma }</a>

            <VocabularyModal card={card} visible={modalVisible} toggle={() => setModalVisible(!modalVisible)}/>
        </td>
        <td>{ card.postAuthorName }</td>
        <td>{ card.approvingName }</td>
        <td>{ card.escalatingName }</td>
    </tr>
};
